import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';

import getEnvConfig from '../../../utils/config/env';

export const commonAiApi = createApi({
    reducerPath: 'commonAi',
    baseQuery: fetchBaseQuery({
        baseUrl: getEnvConfig().env.API_URL,
        prepareHeaders: headers => {
            const token = localStorage.getItem('accessToken');
            headers.set('Authorization', `Bearer ${token}`);
            return headers;
        },
    }),
    tagTypes: ['Common-AI'],

    endpoints: builder => ({
        createAiImage: builder.mutation<{ url: string }, { prompt: string }>({
            query: payload => ({
                url: `/generate-image`,
                method: 'POST',
                body: { ...payload },
            }),
            transformResponse: (response: { data: { url: string } }) => {
                return response.data;
            },
            invalidatesTags: ['Common-AI'],
        }),
    }),
});

export const { useCreateAiImageMutation } = commonAiApi;
